import { ActionTypes } from "../constants/action-type";

const initialState = {
  user: null,
};
export const UserReducer = (state = initialState, { type, payload }) => {
  // console.log("user payload", type , payload)
  switch (type) {
    case ActionTypes.SET_USER:
      return { ...state, user: payload };
    default:
      return state;
  }
};
